// extracted by mini-css-extract-plugin
export var container = "_3f-0";
export var icon = "_3f-1";
export var text = "_3f-2";